export default {
  name: 'ColoredStateBadge',
  props: {
    state: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    badgeColor() {
      return this.getBadgeColorByState();
    },
  },
  methods: {
    getBadgeColorByState(state = this.state) {
      const ERROR_STATES = ['error'];
      const WARNING_STATES = ['canceled', 'aborted', 'timeout'];
      const SUCCESS_STATES = ['finished'];

      const checkStateItemEquality = s => state.toLowerCase() === s;

      if (ERROR_STATES.some(checkStateItemEquality)) {
        return 'error';
      }
      if (WARNING_STATES.some(checkStateItemEquality)) {
        return 'warning';
      }
      if (SUCCESS_STATES.some(checkStateItemEquality)) {
        return 'success';
      }
      return 'primary';
    },
  },
};
